/* DeusDream · Perfumes originales: filtros y compra (diseñador: unidad o pack x2; árabes y body: unidad o x6, surtidos desde 6). Usa DDPerfumePacks. */
(function () {
  'use strict';
  const root = () => {
    const r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return r.endsWith('/') ? r : r + '/';
  };
  const notifyThemeCart = (source, cart) => {
    const promise = Promise.resolve({ cart: { totalQuantity: Number(cart.item_count) || 0 }, detail: { itemCount: Number(cart.item_count) || 0, items: cart.items || [] } });
    const event = new Event('shopify:cart:lines-update', { bubbles: true });
    Object.defineProperties(event, { action: { value: 'update' }, context: { value: 'product' }, lines: { value: [] }, promise: { value: promise } });
    source.dispatchEvent(event);
    document.querySelectorAll('[data-dd-mobile-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
  };

  const init = (section) => {
    if (section.dataset.ddReady) return;
    section.dataset.ddReady = 'true';
    const cards = [...section.querySelectorAll('[data-dd-pf-card]')];
    const empty = section.querySelector('[data-dd-pf-empty]');
    const toast = section.querySelector('[data-dd-pf-toast]');
    let line = 'all', gender = 'all', toastTimer;
    const pre = section.dataset.activeLine;
    if (pre) {
      const tab = section.querySelector('[data-dd-pf-line="' + pre + '"]');
      if (tab) setTimeout(() => tab.click(), 0);
    }

    const apply = () => {
      let shown = 0;
      cards.forEach((card) => {
        const ok = (line === 'all' || card.dataset.line === line) && (gender === 'all' || card.dataset.gender === gender);
        card.hidden = !ok;
        if (ok) { card.style.setProperty('--i', shown % 12); card.style.animation = 'none'; void card.offsetWidth; card.style.animation = ''; shown += 1; }
      });
      if (empty) empty.hidden = shown > 0;
    };

    section.addEventListener('click', async (event) => {
      const tab = event.target.closest('[data-dd-pf-line]');
      if (tab) {
        line = tab.dataset.ddPfLine;
        section.querySelectorAll('[data-dd-pf-line]').forEach((b) => { const on = b === tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); });
        apply();
        return;
      }
      const g = event.target.closest('[data-dd-pf-gender]');
      if (g) {
        gender = g.dataset.ddPfGender;
        section.querySelectorAll('[data-dd-pf-gender]').forEach((b) => b.classList.toggle('is-active', b === g));
        apply();
        return;
      }
      const buy = event.target.closest('[data-dd-pf-buy]');
      if (!buy || buy.classList.contains('is-loading')) return;
      const group = buy.closest('.dd-pf-card__buy');
      const tier = Number(buy.dataset.ddPfBuy) || 1;
      const say = (msg, isError) => {
        if (!toast) return;
        toast.classList.toggle('is-error', !!isError);
        toast.innerHTML = '';
        const span = document.createElement('span'); span.textContent = msg; toast.appendChild(span);
        if (!isError) { const a = document.createElement('a'); a.href = root() + 'cart'; a.textContent = 'Ver carrito'; toast.appendChild(a); }
        toast.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 4200);
      };
      if (!window.DDPerfumePacks) { say('Cargando… probá de nuevo en un segundo.', true); return; }
      buy.classList.add('is-loading');
      try {
        const pfLine = group.dataset.line || 'disenador';
        const isMix = pfLine === 'arabe' || pfLine === 'body';
        const cart = await window.DDPerfumePacks.add({ variantId: group.dataset.variantId, tier: isMix ? 1 : tier, qty: isMix ? tier : 1, line: pfLine, title: group.dataset.title, pct: buy.dataset.pct, each: buy.dataset.each, total: buy.dataset.total, source: buy });
        buy.classList.remove('is-loading');
        if (!cart) return;
        buy.classList.add('is-done');
        setTimeout(() => buy.classList.remove('is-done'), 1600);
        if (isMix) {
          const need = Number(group.dataset.mixQty) || 6;
          const have = (cart.items || []).reduce((s, i) => ((i.properties || {})._dd_pf_line === pfLine ? s + (Number(i.quantity) || 0) : s), 0);
          const label = pfLine === 'arabe' ? 'árabes' : 'body splash';
          say(have >= need ? (tier === 1 ? '1 unidad agregada' : tier + ' unidades agregadas') + ' · ya tenés ' + have + ' ' + label + ': −' + group.dataset.mixPct + '% aplicado' : (tier === 1 ? '1 unidad agregada' : tier + ' unidades agregadas') + ' · sumá ' + (need - have) + ' ' + label + ' más (pueden ser distintos) para −' + group.dataset.mixPct + '%');
        } else {
          say(tier === 1 ? '1 unidad agregada al carrito' : 'Pack x' + tier + ' agregado con −' + buy.dataset.pct + '%');
        }
      } catch (err) {
        buy.classList.remove('is-loading');
        say(err.message || 'No se pudo agregar. Intentá de nuevo.', true);
      }
    });
  };

  const boot = () => document.querySelectorAll('[data-dd-perfumes]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
